import { render } from "./HowItWorks.vue?vue&type=template&id=7834de7a&scoped=true"
const script = {}

import "./HowItWorks.vue?vue&type=style&index=0&id=7834de7a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7834de7a"]])

export default __exports__